import { Box, Typography } from "@mui/material";
import TruncatedText from "../../../Utils/TruncatedText";
import { useNavigate } from "react-router-dom";

const TodaySpecialComponent = ({ data, onDecrement, onIncrement }) => {
  const navigate=useNavigate()
     const GotoDetails=(e,data)=>{
        //console.log("GotoDetails",data)
        const machineId=localStorage.getItem("machineId")
        navigate(`/productdetails/${machineId}/${data.mv_id}/${data.slot_id}`)
      }

  return (
    <>
    {data&&data[0]&&<Box>
      <Typography
        style={{
          color: "rgba(113, 129, 152, 1)",
          fontSize: "17px",
          fontWeight: "500",
          marginTop: "15px",
        }}
      >
        Today’s Special
      </Typography>

      <Box
        className="styles_slider__podEu"
        data-testid="grid-slider"
        style={{ marginTop: "10px" }}
      >
        {data &&
          data[0] &&
          data.map((el, index) => (
            <Box
             onClick={(e)=>{GotoDetails(e,el)}}
              key={index}
              marginBottom="5%"
              boxShadow="0px 4px 10px 0px rgba(56, 79, 111, 0.12)"
              borderRadius="16px"
              width="100%"
              style={{ background: "white" }}
            >
              <Box margin="10px">
                <Box>
                  <Box
                    className="styles_ImageContainer__2rk9a"
                    style={{
                      background: "rgb(255, 255, 255)",
                      height: "92px",
                    }}
                  >
                    <img
                      className="styles_Image__1fplJ"
                      loading="lazy"
                      src={`https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/${el.image_path}`}
                      alt={el.mv_name}
                    />
                  </Box>
                </Box>

                <Box
                  className="styles_containerRestaurant__3vhx3"
                  style={{ padding: "12px!important" }}
                >
                  <div
                    className="styles_containerImageBadge__14fk3"
                    style={{ fontFamily: "Roboto" }}
                  >
                    <div
                      data-testid="resturant-card-name"
                      className="styles_restaurantName__29jAP"
                      style={{ fontSize: "14px" }}
                    >
                      <TruncatedText text={el.mv_name} limit={25} />
                    </div>
                    <div
                      style={{ color: "#94A3B8", fontSize: "12px", marginRight: "8px" }}
                    >
                      Tray <TruncatedText text={el?.slot_id?.toString()} limit={1} />
                    </div>
                  </div>

                  <div>
                    <span
                      data-testid="restaurant-card-cuisines"
                      style={{
                        fontSize: "12px",
                        color: "rgba(148, 163, 184, 1)",
                        fontFamily: "Roboto",
                        fontStyle: "normal",
                        fontWeight: "400",
                        lineHeight: "20px",
                      }}
                    >
                      <span style={{ visibility: "hidden" }}>
                        <TruncatedText text={el.mv_description} limit={25} />
                      </span>
                      <Typography fontSize="12px" style={{ color: "rgba(113, 129, 152, 1)" }}>
                        {el.active_count > 0 && <span>{el.active_count} Left</span>}
                      </Typography>
                    </span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-end",
                      marginTop: el.active_count > 1 ? "0px" : "11px",
                    }}
                  >
                    <h2
                      style={{
                        color: "#718198",
                        textAlign: "right",
                        fontFamily: "Roboto",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: "600",
                        lineHeight: "150%",
                        letterSpacing: "0.2px",
                      }}
                    >
                      ₹ {el?.offer_price?.toFixed(2)}
                    </h2>

                    {el.mycount > 0 ? (
                      <div
                        style={{
                          border: "2px solid rgb(0, 177, 119)",
                          display: "flex",
                          width: "100px",
                          height: "32px",
                          backgroundColor: "rgb(0, 177, 119)",
                          color: "white",
                          justifyContent: "space-around",
                          alignItems: "center",
                          padding: "10px",
                          borderRadius: "7px",
                          cursor: "pointer", // <-- pointer cursor
                        }}
                      >
                        <h3
                          onClick={(e) => onDecrement(e, index, el.slot_id, el.mycount)}
                          style={{ cursor: "pointer" }} // pointer for -
                        >
                          -
                        </h3>
                        {el.mycount}
                        <h3
                          onClick={(e) => onIncrement(e, index, el.slot_id, el.mycount, "add")}
                          style={{ cursor: "pointer" }} // pointer for +
                        >
                          +
                        </h3>
                      </div>
                    ) : (
                      <>
                        {el.active_count > 0 ? (
                          <div
                            style={{
                              border: "2px solid rgb(0, 177, 119)",
                              display: "flex",
                              width: "100px",
                              height: "32px",
                              backgroundColor: "rgba(0, 177, 119, 0.04)",
                              color: "#00B177",
                              justifyContent: "space-around",
                              alignItems: "center",
                              padding: "10px",
                              borderRadius: "7px",
                              fontSize: "14px",
                              fontWeight: "500",
                              cursor: "pointer", // <-- pointer for ADD
                            }}
                            onClick={(e) => onIncrement(e, index, el.slot_id, el.mycount, "add")}
                          >
                            ADD
                          </div>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              width: "100px",
                              height: "32px",
                              backgroundColor: "#8080803d",
                              color: "white",
                              justifyContent: "space-around",
                              alignItems: "center",
                              padding: "10px",
                              borderRadius: "7px",
                              fontWeight: "500",
                            }}
                          >
                            ADD
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </Box>
              </Box>
            </Box>
          ))}
      </Box>
    </Box>}
    </>
  );
};

export default TodaySpecialComponent;
